import { AxiosInstance } from "axios";

export interface EntertainmentArea {
  id: string;
  id_v1?: string;
  metadata: {
    name: string;
  };
  configuration_type: "screen" | "monitor" | "music" | "3dspace" | "other";
  status: "active" | "inactive";
  active_streamer?: { rid: string; rtype: string };
  stream_proxy: {
    mode: "auto" | "manual";
    node: { rid: string; rtype: string };
  };
  channels: Array<{
    channel_id: number;
    position: { x: number; y: number; z: number };
    members: Array<{ rid: string; rtype: string; index: number }>;
  }>;
  service_locations: Array<{
    service: { rid: string; rtype: string };
    positions: Array<{ x: number; y: number; z: number }>;
    equalization_factor: number;
  }>;
}

export async function getEntertainmentAreas(
  axiosInstance: AxiosInstance
): Promise<EntertainmentArea[]> {
  try {
    const response = await axiosInstance.get("/entertainment_configuration");
    const areas: EntertainmentArea[] = response.data.data;
    return areas;
  } catch (err: any) {
    console.error("Failed to retrieve entertainment areas:", err.message);
    return [];
  }
}
